/**
 * ==========================================================================================
 * custom-shop-the-look.js (Versión FINAL, ESTRUCTURADA y ROBUSTA)
 *
 * CORRECCIONES:
 * 1. La 'class ProductItem' está al principio del archivo para evitar errores de referencia.
 * 2. Se usa MutationObserver en <body>, un elemento estable que no es reemplazado por
 * el AJAX de los filtros, garantizando que siempre esté activo para reinicializar.
 * ==========================================================================================
 */

/**
 * ==========================================================================================
 * PASO 1: DEFINICIÓN DE LA CLASE
 * Define cómo funciona cada producto individual en el popup.
 * ==========================================================================================
 */
class ProductItem {
  constructor(container, sectionsToRefresh) {
    this.container = container;
    this.sectionsToRefresh = sectionsToRefresh;
    this.variants = JSON.parse(this.container.querySelector('[data-product-variants-json]').textContent);
    this.form = this.container.querySelector('[data-product-form]');
    this.optionSelectors = this.container.querySelectorAll('[data-option-selector]');
    this.variantIdInput = this.container.querySelector('[data-variant-id-input]');
    this.addToCartButton = this.container.querySelector('.stl-add-to-cart-btn');
    this.priceWrapper = this.container.querySelector('.stl-product-price-wrapper');
    this.productImage = this.container.querySelector('.stl-product-image');

    if (this.optionSelectors.length > 0) {
      this.optionSelectors.forEach(selector => {
        selector.addEventListener('change', this.onVariantChange.bind(this));
      });
    } else if (this.variants.length > 0 && this.variants[0]) {
      this.updateUI(this.variants[0]);
    }

    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
  }
  onVariantChange() { const selectedOptions = this.getSelectedOptions(); const currentVariant = this.findVariant(selectedOptions); if (currentVariant) { this.updateUI(currentVariant); } }
  getSelectedOptions() { const options = []; const fieldsets = this.container.querySelectorAll('.variant-picker__option'); fieldsets.forEach(fieldset => { const selectedRadio = fieldset.querySelector('input[type="radio"]:checked'); if (selectedRadio) options.push(selectedRadio.value); }); return options; }
  findVariant(selectedOptions) { return this.variants.find(variant => { if (variant.options.length !== selectedOptions.length) return false; return selectedOptions.every((option, index) => variant.options[index] === option); }); }
  updateUI(variant) {
    this.variantIdInput.value = variant.id;
    if (this.priceWrapper) {
      const priceWithVatSpan = this.priceWrapper.querySelector('#price-with-vat');
      if (priceWithVatSpan) {
        const currentPriceB = priceWithVatSpan.querySelector('b');
        const comparePriceSpan = priceWithVatSpan.querySelector('span[style*="line-through"]');
        if (variant.compare_at_price > variant.price) {
          if (currentPriceB) currentPriceB.innerHTML = this.formatMoney(variant.price);
          if (comparePriceSpan) {
            comparePriceSpan.style.display = 'inline';
            comparePriceSpan.innerHTML = this.formatMoney(variant.compare_at_price);
          }
        } else {
          if (currentPriceB) currentPriceB.innerHTML = this.formatMoney(variant.price);
          if (comparePriceSpan) {
            comparePriceSpan.innerHTML = '';
            comparePriceSpan.style.display = 'none';
          }
        }
      }
    }
    if (variant.featured_image && this.productImage) {
      this.productImage.src = `${variant.featured_image.src}&width=200`;
    }
    const buttonText = this.addToCartButton.querySelector('.btn-text');
    if (variant.available) {
      this.addToCartButton.removeAttribute('disabled');
      buttonText.textContent = 'AÑADIR';
    } else {
      this.addToCartButton.setAttribute('disabled', 'disabled');
      buttonText.textContent = 'AGOTADO';
    }
  }
  async onFormSubmit(event) {
    event.preventDefault();
    const button = event.target.querySelector('.stl-add-to-cart-btn');
    const originalTextSpan = button.querySelector('.btn-text');
    const feedbackTextSpan = button.querySelector('.btn-feedback');
    const originalButtonText = originalTextSpan.textContent;
    button.setAttribute('disabled', 'disabled');
    originalTextSpan.textContent = 'AÑADIENDO...';
    const formData = new FormData(); formData.append('id', this.variantIdInput.value); formData.append('quantity', event.target.querySelector('[name="quantity"]').value);
    formData.append('sections', this.sectionsToRefresh);
    formData.append('sections_url', window.location.pathname);
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const responseJson = await response.json();
      if (!response.ok) {
        throw new Error(responseJson.description || 'Error al añadir el producto.');
      } document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: responseJson, baseEvent: 'variant:add' } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      originalTextSpan.style.display = 'none';
      feedbackTextSpan.style.display = 'inline';
      setTimeout(() => {
        if (button.getAttribute('disabled')) {
          const currentVariant = this.findVariant(this.getSelectedOptions());
          if (currentVariant && currentVariant.available) {
            button.removeAttribute('disabled');
          }
          originalTextSpan.style.display = 'inline';
          feedbackTextSpan.style.display = 'none';
          originalTextSpan.textContent = originalButtonText;
        }
      }, 2000);
    } catch (error) {
      console.error('Error al añadir al carrito:', error);
      alert(error.message);
      button.removeAttribute('disabled');
      originalTextSpan.textContent = originalButtonText;
    }
  }
  formatMoney(cents, format) {
    if (typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || Shopify.money_format);
    } const value = (cents / 100).toFixed(2);
    return `€${value.replace('.', ',')}`;
  }
}


/**
 * ==========================================================================================
 * PASO 2: FUNCIÓN DE INICIALIZACIÓN PRINCIPAL
 * Busca los elementos STL y les aplica la lógica de carrusel, modal y productos.
 * ==========================================================================================
 */
function initializeShopTheLook(container) {
  const sectionsToRefresh = [];
  const selectors = [
    '[id*="cart-drawer"]', '.cart-drawer', '#CartDrawer',
    '[data-section-type*="cart-drawer"]', '[data-section-type*="free-shipping-bar"]', '[data-section-type="cart-bubble"]'
  ];
  selectors.forEach(selector => {
    const element = document.querySelector(selector);
    if (element && element.dataset.sectionId && !sectionsToRefresh.includes(element.dataset.sectionId)) {
      sectionsToRefresh.push(element.dataset.sectionId);
    }
  });
  const sectionsQueryString = sectionsToRefresh.join(',');
  const stlElements = container.querySelectorAll('.stl-section');

  stlElements.forEach(element => {
    const uniqueId = element.dataset.blockId || element.dataset.sectionId;
    if (!uniqueId) return;

    // Lógica del Modal
    // Lógica del Modal (acepta data-modal-trigger y data-modal-trigger2)
const triggers = element.querySelectorAll('[data-modal-trigger], [data-modal-trigger2]');
const modal = document.getElementById(`stl-modal-${uniqueId}`);

if (triggers.length && modal) {
  const open = (e) => {
    e.preventDefault();
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Opcional: poner foco para permitir ESC
    try { modal.focus(); } catch(e) {}
  };

  const close = () => {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  // Abrir con cualquiera de los triggers
  triggers.forEach(t => {
    if (!t.dataset.initialized) {
      t.addEventListener('click', open);
      t.dataset.initialized = 'true';
    }
  });

  // Cerrar con botones marcados
  modal.querySelectorAll('[data-modal-close]').forEach(btn => {
    if (!btn.dataset.initialized) {
      btn.addEventListener('click', close);
      btn.dataset.initialized = 'true';
    }
  });

  // Cerrar click fuera (overlay)
  if (!modal.dataset.overlayClose) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) close();
    });
    modal.dataset.overlayClose = 'true';
  }

  // Cerrar con ESC
  if (!modal.dataset.escClose) {
    modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
    modal.setAttribute('tabindex', '-1'); // para recibir keydown
    modal.dataset.escClose = 'true';
  }
}


    // Lógica de los productos (usa la clase ProductItem)
    // CÓDIGO MODIFICADO Y CORREGIDO
const productItems = element.querySelectorAll('[data-product-container]');
productItems.forEach(item => {
  // ¡AQUÍ ESTÁ LA SOLUCIÓN!
  // Comprobamos si existe el input de variante antes de crear la clase.
  // Si no existe (porque es un producto B2B), simplemente lo ignoramos.
  const variantInput = item.querySelector('[data-variant-id-input]');

  if (variantInput && !item.dataset.initialized) {
    new ProductItem(item, sectionsQueryString);
    item.dataset.initialized = 'true';
  }
});

    // Lógica del carrusel exterior
    const autoplayCarousel = element.querySelector('[data-carousel-autoplay-id]');
    if (autoplayCarousel) {
      if (autoplayCarousel.dataset.intervalId) { clearInterval(autoplayCarousel.dataset.intervalId); }
      const slides = autoplayCarousel.querySelectorAll('.stl-outer-carousel__slide');
      if (slides.length > 1) {
        let currentIndex = 0;
        const intervalId = setInterval(() => {
          if (slides[currentIndex]) slides[currentIndex].classList.remove('is-active');
          currentIndex = (currentIndex + 1) % slides.length;
          if (slides[currentIndex]) slides[currentIndex].classList.add('is-active');
        }, 9000);
        autoplayCarousel.dataset.intervalId = intervalId;
      }
    }

    // Lógica del carrusel del popup
    const modalCarousel = modal ? modal.querySelector('.stl-carousel') : null;
    if (modalCarousel) {
      const track = modalCarousel.querySelector('.stl-carousel__track');
      const slides = Array.from(track.children);
      const nextButton = modalCarousel.querySelector('.stl-carousel__button--next');
      const prevButton = modalCarousel.querySelector('.stl-carousel__button--prev');
      if (slides.length > 1) {
  let currentIndex = 0;
  const updateCarouselState = () => {
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
    prevButton.disabled = currentIndex === 0;
    nextButton.disabled = currentIndex === slides.length - 1;
  };

  if (!nextButton.dataset.initialized) {
    nextButton.addEventListener('click', () => {
      if (currentIndex < slides.length - 1) { currentIndex++; updateCarouselState(); }
    });
    prevButton.addEventListener('click', () => {
      if (currentIndex > 0) { currentIndex--; updateCarouselState(); }
    });
    nextButton.dataset.initialized = 'true';
    prevButton.dataset.initialized = 'true';
  }

  // Resetear carrusel al abrir desde cualquiera de los triggers
  if (triggers && !modalCarousel.dataset.resetBound) {
    triggers.forEach(t => {
      if (!t.dataset.modalCarouselReset) {
        t.addEventListener('click', () => { currentIndex = 0; updateCarouselState(); });
        t.dataset.modalCarouselReset = 'true';
      }
    });
    modalCarousel.dataset.resetBound = 'true';
  }

  updateCarouselState();
} else if (nextButton && prevButton) {
  nextButton.style.display = 'none';
  prevButton.style.display = 'none';
}
    }
  });
}


/**
 * ==========================================================================================
 * PASO 3: EJECUCIÓN Y OBSERVACIÓN
 * Se ejecuta una vez al cargar la página y luego vigila los cambios para volver a ejecutarse.
 * ==========================================================================================
 */
document.addEventListener('DOMContentLoaded', () => {
    // console.log('STL: DOM cargado. Iniciando y configurando observador.');

    // Ejecutar la lógica en la carga inicial
    initializeShopTheLook(document);

    // Seleccionar el cuerpo del documento como el nodo a observar.
    // Es el único elemento que garantizamos que no será reemplazado por el AJAX de los filtros.
    const targetNode = document.body;

    let debounceTimer;

    // Configurar el observador para vigilar cambios en CUALQUIER LUGAR del cuerpo
    const observer = new MutationObserver((mutationsList, observer) => {
        // Ponemos un pequeño retardo (debounce) para no ejecutar esto 100 veces
        // si el tema hace muchos cambios rápidos en el DOM.
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            // console.log('STL: Se detectó un cambio en el DOM. Buscando elementos nuevos para inicializar...');
            // Volvemos a llamar a la función principal.
            // Es segura de llamar múltiples veces porque tiene comprobaciones internas (!trigger.dataset.initialized)
            // para no añadir listeners a elementos que ya los tienen.
            initializeShopTheLook(document);
        }, 200);
    });

    // Empezar a observar
    observer.observe(targetNode, {
        childList: true, // Observar si se añaden/quitan elementos
        subtree: true    // Observar también sus descendientes
    });
    
    // console.log('STL: Observador de mutaciones activado en <body>.');
});
